import React, { FC } from "react";
import { useStyles } from "./TagStyles";
import { TagProps } from "./types";

const Tag: FC<TagProps> = ({ children, tagContent, anchor, s }) => {
  const styles = useStyles();
  return (
    <div className={styles.tagRoot}>
      {tagContent && (
        <span
          className={styles.tagContent}
          style={{
            left: anchor.horizontal === "left" ? "0" : undefined,
            right: anchor.horizontal === "right" ? "0" : undefined,
            top: anchor.vertical === "top" ? "0" : undefined,
            bottom: anchor.vertical === "bottom" ? "0" : undefined,
            ...s,
          }}>
          {tagContent}
        </span>
      )}
      {children}
    </div>
  );
};

export default Tag;
